module.exports = __webpack_public_path__ + "assets/coloredamex-cd185e.svg";